import { memo } from 'react';
import type { NodeProps } from 'reactflow';
import { MessageSquare } from 'lucide-react';
import { BaseNodeUI } from './BaseNodeUI';

const LLMPromptNode = ({ data, selected }: NodeProps) => (
    <BaseNodeUI
        title={data?.label || 'LLM Prompt'}
        icon={MessageSquare}
        bgClass="bg-gradient-to-br from-violet-500 to-violet-700"
        colorClass="text-violet-600"
        selected={selected}
        isRunning={data?.executionStatus === 'Running'}
        executionStatus={data?.executionStatus}
    >
        LLM Call
    </BaseNodeUI>
);

LLMPromptNode.displayName = 'LLMPromptNode';
export default memo(LLMPromptNode);
